/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface WabunkaSectionSlugViewParams {
  section_id: string;
  slug: string;
  screen_name: string;
}

/**
 * 発火タイミング：各セクションの体験がクリックされた際に発火
 */
export const sendGAWabunkaSectionSlugViewEvent = (sectionId: string, slug: string, screen: string) => {
  sendWabunkaGAEvent('section_slug_view', { section_id: sectionId, slug, screen_name: screen });
};
